"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyableLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCopyToClipboard = require("react-copy-to-clipboard");
var CopyableLink = exports.CopyableLink = function CopyableLink(_ref) {
  var url = _ref.url,
    onCopy = _ref.onCopy,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: url,
    onCopy: onCopy
  }, children);
};
CopyableLink.propTypes = {
  url: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].object.isRequired,
  onCopy: _propTypes["default"].func
};